$(document).ready(function() {
	if(!document.querySelector('.GPC0018')) return false;

	var $obj=$('.GPC0018');
	$obj.find('.resource-item-download button.ico-download').on('click', function() { // LGEVN-282
		var title = $(this).closest('.resource-item').find('.resource-item-title').text();
		if(!title) {
			title = '';
		} else {
			title = changeTitleFormat(title);
		}
		adobeTrackEvent('resource-download', {resource_download_type : title, page_event : {resource_download : true}});

		/* LGEVN-282, BTOBGLOBAL-603 Start */
		if($(this).attr('self-open') === "Y"){
			location.href = $(this).data('url');
		}else{
			window.open($(this).data('url'));
		}
		/* LGEVN-282, BTOBGLOBAL-603 End */
	});
});